export default __webpack_public_path__ + "static/media/circle-bg-astronaut.bc0a4f85.png";